import React from 'react';
import { Redirect } from 'react-router-dom';
import { LocationDescriptor } from 'history';

const RequireProps: React.FC<{ redirect: LocationDescriptor; props: Record<string, any> }> = (props) => {
  const innerProps = props.props;
  const hasAllProps = Object.keys(innerProps).every((k) => Boolean(innerProps[k]));
  if (hasAllProps) {
    return <>{props.children}</>;
  }
  return <Redirect to={props.redirect} />;
};

export default RequireProps;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/RequireProps.tsx